import router from 'next/router';
import { UiTitle, UiLoader } from 'znanie-uikit';

import LayoutConfines from 'components/layout/LayoutConfines';

import EventsList from 'components/event/EventsList';

import LinkTo from 'components/common/LinkTo';
import NoData from 'components/common/NoData';

import { EventType } from 'graphql/types';

import { trackAnalyticsData, AnalyticsEvent } from 'utils/analytics';

import css from './EventsOnMain.module.scss';

interface IProps {
  events: EventType[];
  eventsLoading: boolean;
}

export default function EventsOnMain({ events, eventsLoading }: IProps) {
  const handleShowAllEventsClick = () => {
    trackAnalyticsData(AnalyticsEvent.MAIN_EVENTS_SHOW_ALL_CLICK);
  };

  return (
    <div className={css.block}>
      <LayoutConfines>
        <div className={css.header}>
          <UiTitle size="big" as="h2">
            Мероприятия
          </UiTitle>
          <LinkTo href="/events" onClick={handleShowAllEventsClick} />
        </div>
        <UiLoader loading={eventsLoading}>
          {events.length > 0 ? (
            <EventsList mode="more_btn" events={events} />
          ) : (
            <NoData
              text="Пока нет предстоящих мероприятий, Вы можете ознакомиться с прошедшими"
              btnText="Посмотреть прошедшие"
              onBtnClick={async () => {
                await router.push('/events?show_past_events=true');
              }}
            />
          )}
        </UiLoader>
      </LayoutConfines>
    </div>
  );
}
